import { motion } from 'framer-motion';
import { customEasing } from '../lib/easing';

const focusAreas = [
  'AI productivity measurement',
  'Deployment readiness',
  'Autonomy and dual-use risk',
  'Workforce transition',
];

function ContactSection() {
  return (
    <section id="contact" className="section-asi bg-asi-navy text-white">
      <div className="container-asi">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8, ease: customEasing.smooth }}
          className="grid gap-10 md:grid-cols-[1fr_0.72fr] md:items-start"
        >
          <div>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-asi-copper">
              Contact
            </p>
            <h2 className="mb-6 font-serif text-4xl leading-tight text-white md:text-5xl">
              Get in touch
            </h2>
            <p className="max-w-2xl text-lg leading-8 text-white/78">
              ASI publishes independent synthesis on how AI changes work,
              deployment, security-sensitive systems, and public-interest
              decisions. If you need clear analysis on any of it, reach out.
            </p>

            <a
              href="mailto:contact@aistudies.institute?subject=Inquiry%20for%20AI%20Studies%20Institute"
              className="mt-7 inline-flex min-h-12 items-center justify-center border border-white bg-white px-6 text-sm font-semibold uppercase tracking-wide text-asi-navy transition-colors hover:border-asi-copper hover:bg-asi-copper hover:text-white"
            >
              contact@aistudies.institute
            </a>
          </div>

          <aside className="border border-white/15 bg-white/6 p-5 md:p-6">
            <p className="mb-5 text-sm font-semibold uppercase tracking-[0.18em] text-white/55">
              Focus Areas
            </p>
            <ul className="space-y-3">
              {focusAreas.map((topic) => (
                <li
                  key={topic}
                  className="border-b border-white/10 pb-3 text-sm text-white/82 last:border-b-0 last:pb-0"
                >
                  {topic}
                </li>
              ))}
            </ul>
            <div className="mt-6 border-t border-white/10 pt-5">
              <p className="mb-1 text-xs font-semibold uppercase tracking-[0.18em] text-white/45">
                Location
              </p>
              <p className="mb-0 text-sm text-white/78">
                Research Triangle Park, NC
              </p>
            </div>
          </aside>
        </motion.div>
      </div>
    </section>
  );
}

export default ContactSection;
